import { useState, useCallback } from "react";

export type FeedbackValue = "confirmed" | "not-found" | "not-sure" | null;

export function useFeedbackState() {
  const [feedback, setFeedback] = useState<Record<string, FeedbackValue>>({});

  const setIssueFeedback = useCallback((issueId: string, value: FeedbackValue) => {
    setFeedback((prev) => {
      const current = prev[issueId] ?? null;
      // Toggle off if same value
      const next = current === value ? null : value;
      return { ...prev, [issueId]: next };
    });
  }, []);

  const getFeedback = useCallback(
    (issueId: string): FeedbackValue => feedback[issueId] ?? null,
    [feedback]
  );

  const counts = {
    pending: 0,
    confirmed: 0,
    "not-found": 0,
    "not-sure": 0,
  };

  // Count based on all tracked issues
  const allIds = Object.keys(feedback);
  allIds.forEach((id) => {
    const v = feedback[id];
    if (!v) counts.pending++;
    else counts[v]++;
  });

  return { feedback, setIssueFeedback, getFeedback, counts };
}
